import Lock2 from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/11-Lock-Unlock/Lock2'
import LockUnlock1 from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/11-Lock-Unlock/LockUnlock1'
import Tick from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/33-Form-Validation/Check'
import Calendar1 from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/21-Date-Calendar/Calendar1'
import { IPStatus } from '@components/LPCard/Common'
import { LP_STATUS } from '@utils/constants/learningPath'
import React from 'react'
import { CircleBG } from './style'

const StatusIndicator: React.FC<IPStatus> = ({ status }) => (
  <CircleBG status={status}>
    {status === LP_STATUS.LOCKED && <Lock2 />}
    {status === LP_STATUS.CUSTOM_BOOKED && <Calendar1 />}
    {status === LP_STATUS.UNLOCKED && <LockUnlock1 />}
    {status === LP_STATUS.COMPLETE && <Tick />}
  </CircleBG>
)

export default StatusIndicator
